import React, { memo } from "react"
import { Appearance, ScrollView } from "react-native"
import { observer } from "mobx-react-lite"
import { useStores } from "../../models"
import { OnboardWelcomeModal } from "./onboard-welcome-modal"
// import { CycleToDoModal } from "./cycle-to-do-modal"
// import { WidgetModal } from "./widget-modal"
import { InputProfileModal } from "../../screens/home/home/input-profile-modal"

export interface OnboardModalProps {
  colorScheme?: "light"|"dark"
  scrollViewRef?: { current: ScrollView }
}

/**
 * Describe your component here
 */
export const OnboardModal = memo(observer(function OnboardModal(props: OnboardModalProps) {
  const { colorScheme = "light" || Appearance.getColorScheme(), scrollViewRef } = props;
  const { userStore: { user, skipCoachmark }, widgetStore: { widgets } } = useStores()
  const { state = {}, occupation } = user || {}

  if (!user || !user.phone_verified) return null;
  if (!state.home_coachmark_shown && !skipCoachmark)
    return <OnboardWelcomeModal
      colorScheme={colorScheme}
      scrollViewRef={scrollViewRef}
    />;
  // else if (!state.cycle_to_do_shown)
  //   return <CycleToDoModal scrollViewRef={scrollViewRef} />

  else if (!occupation)
    return <InputProfileModal />

  // for (let index = 0; index < widgets.length; index++) {
  //   const item = widgets[index];
  //   if (!state[`${item.code}_shown`] && (item.tooltip_text || "").length > 0) {
  //     return <WidgetModal item={item} scrollViewRef={scrollViewRef} />
  //   }
  // }
  
  return null;
}))
